import { createApi } from "@reduxjs/toolkit/query/react";

import { baseQuery } from "@tsp-core/store/utils";

import {
  transformLoadSoulEntityInfoPayloadToLoadSoulEntityInfoRequest,
  transformLoadSoulEntityInfoResponseToSoulEntityInfoRecord,
} from "../mappers";
import { LoadSoulEntityInfoPayload, SoulEntityInfoRecord } from "../types";

export const soulEntitiesApi = createApi({
  reducerPath: "@soul-entities/api",
  baseQuery,
  refetchOnFocus: false,
  refetchOnMountOrArgChange: false,
  refetchOnReconnect: false,
  endpoints: (build) => {
    return {
      loadSoulEntityInfo: build.query<SoulEntityInfoRecord, LoadSoulEntityInfoPayload>({
        query: (payload) => {
          return {
            url: "/customTask/fetchData",
            method: "POST",
            body: transformLoadSoulEntityInfoPayloadToLoadSoulEntityInfoRequest(payload),
          };
        },
        transformResponse: transformLoadSoulEntityInfoResponseToSoulEntityInfoRecord,
      }),
    };
  },
});
